import React, { useEffect, useState } from "react";
import { producaov2 as api } from "../../services/apis";
import { useRouter } from "../../hooks/router";
import { Icon, Grid, Label } from "semantic-ui-react";
import Topo from "../../components/Topo";
import Footer from "../../components/Footer";
import {
  Container,
  Content,
  Section,
  Title,
  SemanticImage,
  Span,
  RedirectLink,
  RedirectButton,
} from "./styled";

function Indicacao() {
  const [cupom, setCupom] = useState(null);

  const router = useRouter();

  // const user = getUserNode();
  // const cupomIndicacaoUsuario = (`${user.nome.slice(0, 2)}${user.id}ind`).toUpperCase();

  useEffect(async () => {
    const { id } = router.match.params;

    try {
      const response = await api.get(`cupons/indicacao/${id}`);

      const { cupom } = response.data;

      setCupom(cupom);
    } catch (err) {
      return err;
    }
  }, []);

  return (
    <Container>
      <Topo />
      <Content>
        <>
          <img
            src="https://files.voitto.com.br/ftp-files/assets/images/IndicationBannerExpand.png"
            alt="banner"
            style={{
              marginTop: "40px",
            }}
          />
        </>

        <Section>
          <Title>PARA TER ACESSO AO DESCONTO BASTA:</Title>

          <Grid
            columns={3}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Grid.Column>
              <SemanticImage style={{ maxWidth: "none" }}>
                <Label as="a" color="black" ribbon>
                  {" "}
                  1º{" "}
                </Label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    marginTop: "40px",
                  }}
                >
                  <h4>COPIAR O CUPOM:</h4>

                  <Span>{cupom}</Span>
                </div>
              </SemanticImage>
            </Grid.Column>

            <Grid.Column>
              <SemanticImage style={{ maxWidth: "none" }}>
                <Label as="a" color="black" ribbon>
                  {" "}
                  2º{" "}
                </Label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    marginTop: "80px",
                  }}
                >
                  <h4>ESCOLHER O MELHOR CURSO PARA SUA CARREIRA.</h4>
                  <RedirectButton href="/">
                    <Icon name="play icon icon" />
                    Acessar todos os cursos
                  </RedirectButton>
                </div>
              </SemanticImage>
            </Grid.Column>

            <Grid.Column>
              <SemanticImage style={{ maxWidth: "none" }}>
                <Label as="a" color="black" ribbon>
                  {" "}
                  3°{" "}
                </Label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    marginTop: "80px",
                    textAlign: "center",
                  }}
                >
                  <h4>APLICAR O CUPOM DURANTE A INSCRIÇÃO.</h4>
                  <p>
                    Válido para cursos, workshops e webséries com valor superior
                    a R$100,00
                  </p>
                </div>
              </SemanticImage>
            </Grid.Column>
          </Grid>
        </Section>
      </Content>
      <Footer />
    </Container>
  );
}

export default Indicacao;
